import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { ToastrService } from "ngx-toastr";
import { IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel } from "../../../../../models/osa-execucao-programa-trabalho.model";
import { BaseFormComponent } from "../../../../../shared/components/base-form/base-form.component";
import { ETipoConstatacaoQuestao, ETipoConstatacaoQuestaoDescricao } from "../../../../../models/enum/tipo-constatacao-questao.enum";

@Component({
  selector: 'app-osa-execucao-aba-folha-teste-prog-trab-quest-nova-consta',
  templateUrl: './osa-execucao-aba-folha-teste-prog-trab-quest-nova-consta.component.html',
  styleUrls: ['./osa-execucao-aba-folha-teste-prog-trab-quest-nova-consta.component.scss']
})

export class OsaExecucaoAbaFolhaTesteProgTrabQuestNovaConstaComponent
  extends BaseFormComponent
  implements OnInit, AfterViewInit {

  public model: IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel = {} as IOsaExecucaoProgramaTrabalhoQuestaoConstatacaoModel;
  public enumTipoConstatacaoQuestao = ETipoConstatacaoQuestao;
  public listaTipo: { text: string, value: number }[] = [];
  public isModal: boolean = true;

  public form = new FormGroup({
    titulo: new FormControl("", Validators.required),
    descricao: new FormControl("", Validators.required),
    tipo: new FormControl("", Validators.required),
    criteriosInfrigidos: new FormControl("", Validators.required),
     situacaoEncontrada: new FormControl("", Validators.required)
  });

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    public matDialog: MatDialog,
    public dialogRef: MatDialogRef<OsaExecucaoAbaFolhaTesteProgTrabQuestNovaConstaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super(route, toastr, router, localeService, matDialog);
    if (this.novoRegistro) {
      this.titulo = "Nova Constatação";
    }
  }

  async ngOnInit() {
    this.carregarListaTipo();
  }

  ngAfterViewInit() {
  }

  public async onSubmit() {
    if (this.form.invalid) {
      this.exibirMensagemAlerta("Formulário inválido!");
      return;
    }
    this.atualizarModel(this.form.value);
    this.dialogRef.close(this.model);
  }

  private atualizarModel(values: any) {
    Object.assign(this.model, values);
    this.model.tipoDesc = ETipoConstatacaoQuestaoDescricao[Number(this.model.tipo) as ETipoConstatacaoQuestao] ?? '';
  }

  public onBack() {
    this.dialogRef.close();
  }

  public carregarListaTipo() {
    this.listaTipo = Object.keys(this.enumTipoConstatacaoQuestao)
      .filter(key => !isNaN(Number(key)))
      .map(key => ({
        text: ETipoConstatacaoQuestaoDescricao[Number(key) as ETipoConstatacaoQuestao] ?? '',
        value: Number(key)
      }));
  }
}
